import { QueryFilterType } from 'utils/proptypes';

import base from './baseApi';

const { urls, methods, execute } = base();

const getRoles = (queryFilter: { page: number; limit: number; searchQuery: string; sortBy: string; sortByType: string }) => {
  const method = methods.GET;
  const params: any = Object.fromEntries(Object.entries(queryFilter).filter(([key, value]) => !!value));
  const queryString = new URLSearchParams(params);
  const url = `${urls.role.Roles}?${queryString.toString()}`;
  return execute(method, url, { authorization: true });
};

const getPermissions = () => {
  const method = methods.GET;
  const url = `${urls.role.Roles}/permissions`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const updateRole = (id: any, payload: any) => {
  const method = methods.PUT;
  const url = `${urls.role.Roles}/${id}`;
  const response = execute(method, url, { authorization: true }, payload);

  return response;
};

const createRole = (payload: any) => {
  const method = methods.POST;
  const url = urls.role.Roles;
  const response = execute(method, url, { authorization: true }, payload);

  return response;
};

const deleteRole = (id: any) => {
  const method = methods.DELETE;
  const url = `${urls.role.Roles}/${id}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

export { getRoles, getPermissions, updateRole, createRole, deleteRole };
